// Vendor namespace
window.Snowflake = {
	SfpFrontender: {}
};
